export const ISSUE_TYPES = ["Download", "Upload", "Ping", "Jitter"];

export const issueType = (i) => ISSUE_TYPES.find((t) => i.toLowerCase().includes(t.toLowerCase())) || "Other";

export const netType = (t) => {
  if (t.connection_type === "wifi") return "WiFi";
  const e = (t.effective_type || "").toUpperCase();
  if (t.connection_type === "cellular" || e) return e ? `Cellular ${e}` : "Cellular";
  return "Unknown";
};

const avg = (a) => (a.length ? a.reduce((s, x) => s + x, 0) / a.length : 0);

export const percentile = (arr, p) => {
  if (!arr.length) return null;
  const s = [...arr].sort((a, b) => a - b);
  return s[Math.min(s.length - 1, Math.floor((p / 100) * s.length))];
};

export const groupStats = (tests, keyFn) => {
  const m = {};
  tests.forEach((t) => (m[keyFn(t) ?? "Unknown"] ||= []).push(t));
  return Object.entries(m).map(([key, ts]) => ({
    key,
    n: ts.length,
    dl: avg(ts.map((t) => t.download_mbps)),
    ul: avg(ts.map((t) => t.upload_mbps)),
    ping: avg(ts.map((t) => t.ping_ms)),
    issues: ts.filter((t) => t.issues.length).length,
    issueRate: (ts.filter((t) => t.issues.length).length / ts.length) * 100,
  }));
};

const DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export const byDay = (tests) =>
  groupStats(tests, (t) => t.created_at.slice(0, 10)).sort((a, b) => a.key.localeCompare(b.key));

export const byHour = (tests) => {
  const g = Object.fromEntries(groupStats(tests, (t) => new Date(t.created_at).getHours()).map((r) => [r.key, r]));
  return Array.from({ length: 24 }, (_, h) => ({ key: `${String(h).padStart(2, "0")}h`, ...(g[h] || { n: 0, dl: 0, issueRate: 0 }) }))
    .filter((r) => r.n);
};

export const byWeekday = (tests) => {
  const g = Object.fromEntries(groupStats(tests, (t) => new Date(t.created_at).getDay()).map((r) => [r.key, r]));
  return DAYS.map((d, i) => ({ ...(g[i] || { n: 0, dl: 0, issueRate: 0 }), key: d }));
};

export const issueBreakdown = (tests) => {
  const c = {};
  tests.forEach((t) => t.issues.forEach((i) => { const k = issueType(i); c[k] = (c[k] || 0) + 1; }));
  return Object.entries(c).map(([name, value]) => ({ name, value }));
};
